export default {
  title: 'Suggestions IA',
  subtitle: "Suggestions de l'agent FoodAmigos pour vos restaurants.",
  empty: 'Rien à afficher ici.',
  tabs: {
    pending: 'En attente',
    history: 'Historique',
  },
  table: {
    id: 'ID',
    company: 'Restaurant',
    type: 'Type',
    summary: 'Suggestion',
    created_at: 'Créé',
    status: 'Statut',
    actions: 'Actions',
  },
  statuses: {
    pending: 'En attente',
    confirmed: 'Confirmé',
    applied: 'Appliqué',
    rejected: 'Rejeté',
    failed: 'Échoué',
    expired: 'Expiré',
  },
  types: {
    'smart_pricing.global_reduce': 'Remise sur tout le menu',
    'smart_pricing.category_reduce': 'Remise par catégorie',
    'competitor_listing.confirm': 'Confirmer la fiche marketplace',
    'catalog.price_correct': 'Correction de prix',
    'catalog.add_item': 'Ajouter un article manquant',
    'catalog.quality': 'Qualité du contenu',
    'catalog.reorder': 'Réorganisation du menu',
  },
  actions: {
    review: 'Examiner',
    confirm: 'Confirmer',
    reject: 'Rejeter',
    cancel: 'Annuler',
    edit: 'Modifier',
  },
  edit: {
    label: 'Décrivez la modification souhaitée (une nouvelle révision est générée)',
    placeholder: 'Décrivez la modification souhaitée',
    placeholders: {
      'smart_pricing.global_reduce':
        "p. ex. passer à 15 %, le renommer en « Summer -15% » ou l'appliquer uniquement en livraison",
      'smart_pricing.category_reduce': 'p. ex. régler la remise Boissons à 10 % et supprimer le retrait',
      'catalog.price_correct': 'p. ex. supprimer la correction « Cola » ou fixer « Pizza » à 7,50 €',
      'catalog.add_item': "p. ex. supprimer l'article « Water » ou fixer « Falafel Wrap » à 6,50 €",
      'catalog.quality': 'p. ex. retirer les articles « Fries » et « Cola » de la liste',
      'catalog.reorder': 'p. ex. mettre Boissons en dernier et déplacer le best-seller en tête de Bowls',
      'competitor_listing.confirm': 'p. ex. remplacer le lien Uber Eats par https://…, ou ajouter Wolt : https://…',
    },
    submit: 'Générer une révision',
  },
  revisions: {
    label: 'Révision',
    original: 'Original',
    revision_n: 'Révision {{n}}',
  },
  detail: {
    title: 'Détail de la suggestion',
    targets: 'Articles concernés',
    evidence: "Pourquoi l'agent suggère cela",
    no_targets: "Aucun détail d'article fourni.",
    composed_from: 'Composé de',
    items_suffix: 'articles',
    nutrition: 'Nutrition',
    uncategorized: 'Non catégorisé',
    decided_by: 'Décidé par',
    decision_note: 'Note',
    category_existing: 'existante',
    category_new: 'nouvelle',
    product: 'Produit',
    price_change: 'Changement de prix',
    no_items: 'Aucun article',
    fills_image: '+ image',
    fills_description: '+ description',
    fills_nutrition: '+ nutrition',
    fills_modifiers: '+ modificateurs',
    competitor_links: 'Liens concurrents',
    no_competitor_links: "Aucun lien concurrent résolu pour l'instant.",
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Rejeter cette suggestion',
    note_label: 'Motif',
    note_placeholder: 'Expliquez brièvement pourquoi vous rejetez cette suggestion',
  },
  toasts: {
    load_failed: 'Impossible de charger les suggestions',
    confirmed: 'Suggestion confirmée',
    rejected: 'Suggestion rejetée',
    action_failed: "Impossible d'effectuer cette action",
    revision_created: 'Nouvelle révision générée',
    revision_failed: 'Impossible de générer une révision depuis cette instruction',
    choose_revision: 'Cette suggestion a plusieurs révisions — ouvrez-la et choisissez-en une à confirmer',
  },
};
